<template>
  <div class="detail-wrap">
    <div>
      <!-- 品牌信息 -->
      <div class="d-cont edit-mce-box">
        <div class="d-item">
          <div class="title">{{ showData.title }}</div>
          <div class="source"><span>来源：{{ showData.createBy }}</span>{{ showData.createTime }}</div>
          <div v-html="showData.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


import api from "@/api/projectApi";

export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {},
  data() {
    return {
      dataId: null,
      showData: null
    }
  },
  computed: {},
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    console.log(this.dataId)
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http.post(api.basBulletin.getDataUrl, {id: this.dataId}).then(res => {
        this.showData = res.data.data
      })
    }
  },
};

</script>
<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 30px;
  margin: 10px 0
}

.source {
  color: #a7a7a7;
  margin-bottom: 10px;
  font-size: 16px;

  span {
    margin-right: 20px;
  }
}
</style>
